import { createSlice } from "@reduxjs/toolkit";

const initialContactState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    contactDetails: undefined,
    lastError: null,
};

export const callTypes = {
    list: "list",
    action: "action",
};

export const contactSlice = createSlice({
    name: "contact",
    initialState: initialContactState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        //getContactDetails
        contactDetailsFetched: (state, action) => {
            const { contactDetails } = action.payload;
            // console.log('data',action.payload)

            state.actionsLoading = false;
            state.contactDetails = contactDetails;
            state.error = null;
        },
        // updateContact
        contactUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            // state.contactDetails = action.payload.contact;
        },
        // deleteContact
        contactDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.filter(
                (el) => el._id !== action.payload.contact_id
            );
        },
        // remove contact details
        remmoveContactDetails: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.contactDetails = undefined;
            state.error = null;
        },
    },
});
